export default __webpack_public_path__ + "static/media/rubicon.8ead0cfc.jpg";